export default {
  viewMode(state) {
    return id => state.views[id];
  },
};
